import classNames from 'classnames';
import './Icon.scss';

export type IconProps = {
  display?: 'block';
} & JSX.IntrinsicElements['svg'];
export const Icon = ({
  className,
  display,
  xmlns = 'http://www.w3.org/2000/svg',
  ...props
}: IconProps) => (
  <svg
    className={classNames('icon', { [`icon-display-${display}`]: display }, className)}
    xmlns={xmlns}
    {...props}
  />
);
